export const TABLE_PAGE_SIZE = 25;
export const PAGE_LIMIT = 20;
